import notFoundJson from 'static/json/not_found.json';
import locales from 'locales';
import Content from './partial/Content';

export default function NotFound() {
  return (
    <Content image={notFoundJson} title={locales.pageNotFound} isNotFound />
  );
}
